export const parseUserListToTable = (formlists) => {
    let formlist = [];
    formlists.response.items.map(formItem => {
        try {
            formlist.push({
                key: `${formItem.id}`,
                id: `${formItem.id}`,
                name: `${formItem.name ? formItem.name : ''}`,
                userName: `${formItem.userName ? formItem.userName : ''}`,
                email: `${formItem.email ? formItem.email : ''}`,
                phoneNumber: `${formItem.phoneNumber ? formItem.phoneNumber : ''}`,
                builderLocationId: formItem.builderLocationId,
                companyLocationId: `${formItem.companyLocationId ? formItem.companyLocationId : ''}`,
                locationId: `${formItem.locationId ? formItem.locationId : ''}`,
                isActive: formItem.isActive,
                isDeleted: formItem.isDeleted,
                profiles: formItem.profiles,
                languageId: `${formItem.languageId ? formItem.languageId : ''}`,
                parentId: `${formItem.parentId ? formItem.parentId : ''}`,
                parentLocationName: `${formItem.parent ? (formItem.parent && formItem.parent.location) ? formItem.parent.location.name : '' : ''}`,
                builderLocations: formItem.builderLocations.map(l => l.locationId),
                lastLogin: formItem.lastLogin,
                isSSOUser: formItem.isSSOUser,
                ssoSignInInformation: formItem.ssoSignInInformation,
                docsApprover: formItem.docsApprover,
                pendingTasks: formItem.pendingTasks,
                showOnlyMyTasks: formItem.showOnlyMyTasks,
            });
        } catch (error) {

        }
    });
    return formlist;
}

export const parseToTopicList = (topicLists) => {
    let topicList = [];
    topicLists.response.map(topicItem => {
        topicList.push({
            key: `${topicItem.id}`,
            id: `${topicItem.id}`,
            name: `${topicItem.name ? topicItem.name : ''}`,
            code: `${topicItem.code ? topicItem.code : ''}`,
        });
    });
    return topicList;
}

export const parseToLocationList = (dataLists) => {
    let locationList = [];
    dataLists.response.items.map(locationItem => {
        locationList.push({
            name: `${locationItem.name}`,
            canonicalName: `${locationItem.canonicalName ? locationItem.canonicalName : ''}`,
            id: `${locationItem.id ? locationItem.id : ''}`
        });
    });
    return locationList;
}

export const parseToRolesList = (dataLists) => {
    let rolesList = [];
    dataLists.data.map(rolesItem => {
        rolesList.push({
            name: `${rolesItem.name}`,
            id: `${rolesItem.id ? rolesItem.id : ''}`
        });
    });
    return rolesList;
}

export const parseToLanguagesList = (dataLists) => {
    let languagesList = [];
    dataLists.data.map(languagesItem => {
        languagesList.push({
            name: `${languagesItem.name}`,
            id: `${languagesItem.id ? languagesItem.id : ''}`
        });
    });
    return languagesList;
}

export const parseToUsersList = (dataLists) => {
    let usersList = [];
    dataLists.response.map(usersItem => {
        usersList.push({
            name: `${usersItem.name}`,
            id: `${usersItem.id ? usersItem.id : ''}`,
            locationName: `${usersItem.location ? usersItem.location.name : ''}`
        });
    });
    return usersList;
}